import {BaseCachedService} from './Core/BaseCachedService';

class UnitService extends BaseCachedService {
    get Url() { return super.Url + "/units"; }
    get ModelName() { return "Unit"; }
    get PrimaryKeyProperty() { return "unitId"; }
}

export const service = new UnitService();

